export default "__VITE_ASSET__DJLxifvP__"